var isProduction = process.env.NODE_ENV === 'production';
export default function warning(condition, message, serious) {
    if (serious === void 0) { serious = false; }
    if (!isProduction && condition) {
        var text = "Warning: " + message;
        serious ? console.error(text) : console.warn(text);
    }
}
//# sourceMappingURL=warning.js.map